import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery, { UseRestQueryResponse } from "@/remoteState/useRestQuery";
import { AttachmentWrapper } from "@/types/models/ContentAttachment.interface";

const useContentAttachmentsGet = (
  contentId: string,
): UseRestQueryResponse<AttachmentWrapper> => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/content-document/${contentId}/attachments/`;
  return useRestQuery(requestUrl);
};

export default useContentAttachmentsGet;
